import { ChangeDetectionStrategy, Component, computed, inject, Signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MenuButtonComponent } from '@core/menu/menu-button/menu-button.component';
import { ApplicationStore } from '@core/store/application.store';
import { AuthStore } from '@features/auth/store/auth.store';
import { LanguageSwitchComponent } from '@shared/components/language-switch/language-switch.component';
import { MenuUserComponent } from '../menu/menu-user/menu-user.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'fc-header',
  templateUrl: './header.component.html',
  imports: [LanguageSwitchComponent, MenuButtonComponent, MenuUserComponent, RouterModule],
})
export class HeaderComponent {
  private readonly applicationStore = inject(ApplicationStore);
  private readonly authStore = inject(AuthStore);

  readonly isAuthenticated: Signal<boolean> = computed(() => this.authStore.token() !== null);
  readonly isMobile: Signal<boolean> = this.applicationStore.isMobile;
  readonly title: Signal<string> = this.applicationStore.pageName;
}
